'use strict'

import { loadComponent } from './utils/load-component';
import { getAllDigitalConcerts } from '../services/digital-inventory';

loadComponent('is-purchased', {
    props: {
        view: {
            type: String,
        },
        id: {
            type: Number,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                Purchased: false,
                Type: '',
            },
        }
    },

    beforeMount() {
        getAllDigitalConcerts().then(response => {

            for (let i = 0; i < response.length; i++) {
                if (parseInt(response[i].id, 10) === parseInt(this.id, 10)) {
                    this.ViewModel.Type = response[i].type;
                    break;
                }
            }

            const found = response.find(item => {
                return parseInt(item.id, 10) === parseInt(this.id, 10);
            });

            if (found && found.video_id) {
                this.ViewModel.Purchased = true;
            }
        }).finally(() => {
            this.ViewModel.Loading = false;
        });
    },
});
